import store from '@/store'

export default {
    install(Vue) {
        Vue.prototype.flushSession = function() {
            sessionStorage.setItem("store", JSON.stringify(store.state));
            store.replaceState(
                Object.assign({},
                    store.state,
                    JSON.parse(sessionStorage.getItem("store"))
                )
            );
        };
        Vue.prototype.copyVuex = function() {
            //在页面加载时读取sessionStorage里的状态信息
            if (sessionStorage.getItem("store")) {
                store.replaceState(
                    Object.assign({}, store.state, JSON.parse(sessionStorage.getItem("store")))
                );
            }
            //在页面刷新时将vuex里的信息保存到sessionStorage里
            window.addEventListener("beforeunload", () => {
                sessionStorage.setItem("store", JSON.stringify(store.state));
            });
        }
    }
}